import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Select from 'react-select';
import RadioButton from '../CommonComponent/RadioButton';
import Building from '../../../images/icons/building.svg';
import Home from '../../../images/icons/home.svg';
import Dl from '../../../images/icons/dl.svg';
import Utility from '../../../images/icons/utility.svg';
import VotersID from '../../../images/icons/votersID.svg';
import Passport from '../../../images/icons/passport.svg';
import NewDrivingLicense from './NewDrivingLicense';
import DrivingLicenseDetails from '../AddressProof/DrivingLicenseDetails';
import OfficeUpload from './OfficeUpload';
import PassportComp from '../../../containers/PartnerKyc/PassPort/PassPort';
import RentedUpload from './RentedUpload';
import UtilityOptionsUpload from '../CommonComponent/UtilityOptionsUpload';
import UtilityOptionsDetails from '../CommonComponent/UtilityOptionsDetails';
import VoterID from '../../../containers/PartnerKyc/VoterID/VoterID';
import UtilityFieldLabels from './UtilityFieldLabels';
import { currentYear } from '../CommonComponent/CommonDatePicker';
import {
  getPresignedUrl,
  getLpgInfo,
  getPngInfo,
  UpdateKYCstepAPI
} from '../../../common/constants/api';

import { getUserId } from '../../../common/utils/cookie-utils';
import './AddressProof.css';
const dl_icon = <img className="w-6 h-4" src={Dl}></img>;
const utility_icon = <img className="w-6 h-4" src={Utility}></img>;
const votersID_icon = <img className="w-6 h-4" src={VotersID}></img>;
const passport_icon = <img className="w-6 h-4" src={Passport}></img>;

const uploadTypeOptions = [
  {
    value: 'DrivingLicense',
    label: (
      <span className="flex flex-start">
        <span> {dl_icon}</span>
        <span className="px-6">Driving License</span>
      </span>
    )
  },
  {
    value: 'VoterID',
    label: (
      <span className="flex flex-start ">
        <span>{votersID_icon}</span>
        <span className="ml-6">Voter ID</span>
      </span>
    )
  },
  {
    value: 'UtilityBill',
    label: (
      <span className="flex flex-start">
        <span>{utility_icon}</span>
        <span className="ml-6">Utility Bill</span>
      </span>
    )
  },
  {
    value: 'Passport',
    label: (
      <span className="flex flex-start">
        <span>{passport_icon}</span> <span className="ml-6">Passport</span>
      </span>
    )
  }
];

const ValidationSchema = Yup.object().shape({
  drivingLicense: Yup.object().shape({
    fullName: Yup.string().required('Required'),
    fatherName: Yup.string().required('Required'),
    address: Yup.string()
      .min(15, 'min 15 digit required')
      .required('Required'),
    date: Yup.object().shape({
      value: Yup.string().required('Required')
    }),
    month: Yup.object().shape({
      value: Yup.string().required('Required')
    }),
    year: Yup.object().shape({
      value: Yup.string().required('Required')
    }),
    imgUrl: Yup.string().required('Required'),
    drivingLicenseNo: Yup.string()
      .min(13, 'dl_no should be 13 digit ')
      .max(13, 'dl_no should be 13 digit ')
      .required('Required'),
    bloodGroup: Yup.string().required('Required')
  }),

  utilityBill: Yup.object().shape({
    utilityBillType: Yup.string().required('Required'),
    utilityServiceProvider: Yup.string().required('Required'),
    consumerID: Yup.string()
      .min(17, 'must be 17 digit')
      .max(17, 'must be 17 digit')
      .required('Required'),
    buisnessPartnerNo: Yup.string().required('Required'),
    utilityBillDetails: Yup.object().shape({
      address: Yup.string().required('Required')
    })
  }),

  rented: Yup.object().shape({
    imgUrl: Yup.string().required('Required'),
    pincode: Yup.string()
      .required('Required')
      .max(6)
      .matches(/\d{6}/, 'Pincode should be 6 digit number'),
    address: Yup.string()
      .min(15, 'address cant be less that 15 characters')
      .required('Required')
  }),
  office: Yup.object().shape({
    imgUrl: Yup.string().required('Required'),
    pincode: Yup.string()
      .required('Required')
      .max(6)
      .matches(/\d{6}/, 'Pincode should be 6 digit number'),
    address: Yup.string().required('Required')
  }),

  homeOrOfficeOrNone: Yup.string().required('Please Select One Of The Options'),
  selectOffice: Yup.string().required('Required'),
  selectType: Yup.string().required('Required'),
  residenceOwnedType: Yup.string().required('Required'),
  selectedOption: Yup.string().required('Required')
});

const AddressProof = props => {
  const [fileUploadErrors, setFileUploadErrors] = React.useState({
    'utilityBill.files': '',
    'rented.files': '',
    'office.files': ''
  });
  let url, requestId;

  // function to upload file to the server
  const genericFileUploader = file => {
    return getPresignedUrl({
      partnerId: parseInt(getUserId()),
      kycStepId: 3,
      docTypeId: 4,
      fileType: 'png'
    })
      .then(res => {
        url = res.url;
        requestId = res.requestId;
        Axios.put(res.url, file, {
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        })
          .then(res => {
            if (res.status == 200) {
              // alert('Document Successfully uploaded')

              UpdateKYCstepAPI({
                url: url,
                requestId: requestId
              })
                .then(res => {
                  console.log('response from UpdateKYCstepAPI:', res);
                  return res;
                })
                .catch(err => {
                  console.log('error updating kyc step', err);
                  // return alert('server Error please try again');
                });
            } else {
              // alert('server Error please try again');

              return false;
            }
          })
          .catch(err => {
            console.log({ err: err.status });
            // alert('error uploading the front dl please try again');
          });
      })
      .catch(err => {
        // return alert('error in uploading dl', err);
      });
  };
  return (
    <Formik
      initialValues={{
        drivingLicense: {
          fullName: '',
          fatherName: '',
          address: '',
          date: {
            value: '',
            label: 'Date'
          },
          month: {
            value: '',
            label: 'Month'
          },
          year: {
            value: String(currentYear - 18),
            label: String(currentYear - 18)
          },
          imgUrl: [],
          files: [],
          drivingLicenseNo: '',
          bloodGroup: ''
        },

        utilityBill: {
          utilityBillType: '',
          utilityServiceProvider: '',
          consumerID: '',
          buisnessPartnerNo: '',
          imgUrl: [],
          files: '',
          utilityBillDetails: null
        },
        rented: {
          imgUrl: [],
          files: '',
          pincode: '',
          address: '',
          city: '',
          state: ''
        },
        office: {
          imgUrl: [],
          files: '',
          pincode: '',
          address: '',
          city: '',
          state: ''
        },
        homeOrOfficeOrNone: '',
        selectOffice: '',
        selectType: '',
        residenceOwnedType: '',
        selectedOption: ''
      }}
      validationSchema={ValidationSchema}
    >
      {formik => {
        const {
          values: data,
          errors,
          touched,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldTouched,
          setTouched,
          setErrors,
          isValid,
          setFieldValue,
          setFieldError,
          isSubmitting,
          validateField
        } = formik;
        // console.log(data.homeOrOfficeOrNone);
        function setData(key, value) {
          // console.log('setting Data', key, value);
          formik.setFieldValue(key, value);
        }

        const formMapping = {
          'STEP-0': 'STEP-0',
          'STEP-1': 'STEP-1'
        };

        const [stepsInfo, setstepsInfo] = useState(formMapping);
        const [canProceed, setCanProceed] = useState(false);

        function shouldShow(key) {
          return stepsInfo[key] !== undefined;
        }
        const {
          homeOrOfficeOrNone,
          selectOffice,
          selectType,
          residenceOwnedType,
          selectedOption,
          utilityBill
        } = data;
        console.log(formik);

        const { utilityBillDetails, utilityServiceProvider } = utilityBill;

        // submitValidator
        const submitValidator = () => {
          if (canProceed) return true;
          if (
            (!errors.office || !errors.rented || !errors.drivingLicense) &&
            touched.homeOrOfficeOrNone
          ) {
            return true;
          } else {
            return false;
          }
        };

        ///for home and office or none
        function onChangeHomeOffice(e) {
          setData('homeOrOfficeOrNone', e.target.value);
          if (e.target.value === 'Home') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-2': 'STEP-2'
            });
          } else if (e.target.value === 'Office') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-2-isOffice': 'STEP-2-isOffice'
            });
          }
        }
        // only for office
        function onChangeOffice(e) {
          setData('selectOffice', e.target.value);
          if (e.target.value === 'notOffice') {
            setstepsInfo({
              ...stepsInfo
            });
          } else if (e.target.value === 'haveOffice') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-2-haveOffice': 'STEP-2-haveOffice'
            });
          }
        }

        function onChangeRadio(e) {
          setData('selectType', e.target.value);

          if (e.target.value === 'Owned') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-3': 'STEP-3'
            });
          } else if (e.target.value === 'Rented') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-3-Rented': 'STEP-3-Rented'
            });
          }
        }
        function onChangeResidenceOwnedType(e) {
          setData('residenceOwnedType', e.target.value);
          setstepsInfo({
            ...stepsInfo,
            'STEP-4': 'STEP-4'
          });
        }

        function onChangeUtilityOptions(e) {
          setData('utilityBill.utilityBillType', e.target.value);
          if (e.target.value === 'LPG') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-6-LPG': 'STEP-6'
            });
          } else if (e.target.value === 'PNG') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-7-PNG': 'STEP-7-PNG'
            });
          } else if (e.target.value === 'ElectricityBill') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-8-E-BILL': 'STEP-8-E-BILL'
            });
          }
        }

        //for select option
        function handleSelectOption(data) {
          if (data.value === 'DrivingLicense') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-10-DL': 'STEP-10-DL'
            });
          }
          if (data.value === 'UtilityBill') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-5': 'STEP-5'
            });
          }

          if (data.value === 'VoterID') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-16': 'STEP-16'
            });
          }

          if (data.value === 'Passport') {
            setstepsInfo({
              ...stepsInfo,
              'STEP-17': 'STEP-17'
            });
          }
          setData('selectedOption', data);
        }
        // uploading file for  office
        // submit validation for office
        useEffect(() => {
          !errors.office && touched.office
            ? setCanProceed(true)
            : setCanProceed(false);
        }, [data.office]);
        useEffect(() => {
          if (data.office.imgUrl.length === 1 && data.office.imgUrl[0]) {
            genericFileUploader(data.office.imgUrl[0])
              .then()
              .catch('Error Uploading office document');
          }
        }, [data.office.imgUrl, data.office.files]);

        // file uploading for rented
        useEffect(() => {
          if (data.rented.imgUrl.length === 1 && data.rented.imgUrl[0]) {
            genericFileUploader(data.rented.imgUrl[0])
              .then()
              .catch('Server error, please upload again');
          }
        }, [data.rented.imgUrl, data.rented.files]);

        useEffect(() => {
          // Both the image are loaded
          console.log(data.drivingLicense.imgUrl);
          if (
            data.drivingLicense.imgUrl.length === 2 &&
            data.drivingLicense.imgUrl[0] &&
            data.drivingLicense.imgUrl[1]
          ) {
            genericFileUploader(data.drivingLicense.imgUrl[0])
              .then()
              .catch('error uplaoding dl front,please try again');
            genericFileUploader(data.drivingLicense.imgUrl[1])
              .then(
                // alert('dl back uploaded successfully'),
                setstepsInfo({
                  ...stepsInfo,
                  'STEP-11': 'STEP-11',
                  'STEP-0': undefined
                })
              )
              .catch('error uploading dl back ,please try again');
          }
          // }, []);
        }, [data.drivingLicense.imgUrl, data.drivingLicense.files]);

        useEffect(() => {
          // Both the image are loaded

          if (
            data.utilityBill.imgUrl.length === 1 &&
            data.utilityBill.imgUrl[0]
          ) {
            const { utilityBillType } = data.utilityBill;

            switch (utilityBillType) {
              case 'LPG':
                handleVerifyAndSubmit();
                genericFileUploader(data.utilityBill.imgUrl[0])
                  .then()
                  .catch('sorry!! error uploading the file please try again');

                break;
              case 'PNG':
                {
                  handleVerifyAndSubmit();
                  genericFileUploader(data.utilityBill.imgUrl[0])
                    .then(alert('file uploaded successfully'))
                    .catch('sorry!! error uploading the file please try again');
                }
                break;
              case 'ElectricityBill':
                {
                  setstepsInfo({
                    ...stepsInfo,
                    'STEP-14': 'STEP-14',
                    'STEP-0': undefined
                  });
                }
                break;

              default:
                return;
            }
          }
        }, [data.utilityBill.files]);

        function getUtilityDetailsOptions() {
          const res = [];
          if (
            (utilityBill.utilityBillType === 'LPG' ||
              utilityBill.utilityBillType === 'PNG') &&
            utilityBillDetails
          ) {
            const { name, address, bookingDate } = utilityBillDetails;

            if (name !== undefined) {
              res.push({
                place_holder: 'Name',
                type: 'text',
                disabled: true,
                value: utilityBillDetails['name']
              });
            }

            if (address !== undefined) {
              res.push({
                place_holder: 'Address',
                type: 'text',
                disabled: false,
                name: 'utilityBill.utilityBillDetails.address',
                value: utilityBillDetails['address'],
                onChange: e => {
                  setData(
                    'utilityBill.utilityBillDetails.address',
                    e.target.value
                  );
                },
                onBlur: handleBlur
              });
            }

            if (bookingDate !== undefined) {
              res.push({
                place_holder: 'Booking Date',
                type: 'text',
                disabled: true,
                value: utilityBillDetails['bookingDate']
              });
            }

            // return res;
          }

          return res;
        }

        function uploadImageFlow({
          file,
          kycStepId,
          docTypeId,
          onSuccessUpload
        }) {
          // Right now hard code for lpg flow, need to make it generic once we start png flow
          function sendFile(signedUrlResponse) {
            const file_ = file;
            const { url } = signedUrlResponse;

            Axios.put(url, file_, {
              headers: {
                'Content-Type': 'application/octet-stream'
              }
            })
              .then(res => {
                if (res.status == 200) {
                  // need to make this api call https://api-dev.fincity.in/kyc/address-proof/lpg

                  if (onSuccessUpload) {
                    onSuccessUpload({ res });
                  }
                } else {
                  console.log('error it is file upload itself failed');
                }
              })
              .catch(err => {
                console.log({ err: err.status });
              });
          }
          let data = {
            partnerId: parseInt(getUserId()),
            kycStepId,
            docTypeId,
            fileType: ''
          };

          getPresignedUrl(data) /// 1st api call
            .then(data => {
              sendFile(data);
            })
            .catch(err => {
              // alert('!!Some Error occured');
            });
        }

        async function handleVerifyAndSubmit() {
          // handleSubmit();
          const {
            utilityBillType,
            utilityServiceProvider,
            consumerID,
            buisnessPartnerNo
          } = data.utilityBill;
          if (fileUploadErrors['utilityBill.files']) {
            return;
          }

          if (utilityBillType === 'LPG') {
            if (utilityServiceProvider && consumerID) {
              uploadImageFlow({
                onSuccessUpload: async () => {
                  try {
                    const lpgInfo = await getLpgInfo({
                      lpgId: utilityBill.consumerID, /// test ids
                      serviceProvider: '1' // from where it will come
                    });
                    if (!lpgInfo.isAxiosError) {
                      if (lpgInfo) {
                        console.log('checking lpg', lpgInfo);

                        setData('utilityBill.utilityBillDetails', lpgInfo);
                        setstepsInfo({
                          ...stepsInfo,
                          'STEP-12': 'STEP-12',
                          'STEP-0': undefined
                        });
                      }
                    } else {
                      const message = get(lpgInfo, 'data.message', '');
                      setFieldError('utilityBill.consumerID', message);
                    }
                  } catch (e) {
                    // const message = get(e)
                    // set formik set error for form
                    console.log('failure');
                  }
                },
                docTypeId: 5,
                kycStepId: 3,
                file: utilityBill.files[0]
              });
            }
            // add check if consumer id is there.
          }

          if (utilityBillType === 'PNG') {
            if (utilityServiceProvider) {
              let payloadPng = {};
              switch (utilityServiceProvider) {
                case 'IG':
                  {
                    payloadPng = {
                      serviceProviderCode: utilityServiceProvider,
                      businessPartnerNumber: buisnessPartnerNo
                    };

                    console.log('ig case');
                  }
                  break;
                case 'AG':
                  {
                    payloadPng = {
                      serviceProviderCode: utilityServiceProvider,
                      consumerId: consumerID
                    };
                    console.log('ag gas');
                  }
                  break;
                case 'MG': {
                  payloadPng = {
                    serviceProviderCode: utilityServiceProvider,
                    businessPartnerNumber: buisnessPartnerNo,
                    consumerId: consumerID
                  };
                  console.log('mg gas');
                }
              }

              uploadImageFlow({
                onSuccessUpload: async () => {
                  try {
                    const pngInfo = await getPngInfo(payloadPng);
                    if (!pngInfo.isAxiosError) {
                      if (pngInfo) {
                        setData('utilityBill.utilityBillDetails', pngInfo);
                        setstepsInfo({
                          ...stepsInfo,
                          'STEP-13': 'STEP-13',
                          'STEP-0': undefined
                        });
                      }
                    } else {
                      const message = get(pngInfo, 'data.message', '');
                      setFieldError('utilityBill.consumerID', message);
                      setFieldError('utilityBill.buisnessPartnerNo', message);
                    }
                  } catch (e) {
                    // set formik set error for form
                    console.log('failure');
                  }
                },
                docTypeId: 5,
                kycStepId: 3,
                file: utilityBill.files[0]
              });
            }
          }
        }
        //sad
        return (
          <>
            {shouldShow('STEP-0') && (
              <div className="w-full pb-6">
                <div
                  className=" mainAddressContainer mx-3 pb-6 px-5 sm:px-0
                 sm:py-6 sm:mt-8  md:pt-0
              rounded-lg bg-white text-center text-roboto font-light"
                >
                  <div
                    className="text-black-400 font-Roboto font-medium text-sm text-left
          bg-grey-800 md:bg-white "
                  >
                    Please choose your Home and Work Address{' '}
                    <img className="inline" src={Home}></img> and work{' '}
                    <img className="inline" src={Building} alt="" /> address.
                  </div>
                  {/* Current Accomodation Type start*/}
                  {/* ////adding new option home or office////// */}
                  {shouldShow('STEP-1') && (
                    <div className="residence-container flex flex-col mt-12 mr-12">
                      <div className="text-sm text-left text-black-400 font-bold text-roboto mb-2">
                        Please choose your Address :
                      </div>
                      <div className="flex fex-col items-start">
                        <div className="flex items-center">
                          <RadioButton
                            name="homeOrOfficeOrNone"
                            value="Home"
                            checked={homeOrOfficeOrNone === 'Home'}
                            onChange={e => {
                              handleChange(e);
                              onChangeHomeOffice(e);
                            }}
                            onBlur={handleBlur}
                          />
                          <label
                            htmlFor="Owned"
                            className="text-black-400 text-sm m-2"
                          >
                            Home
                          </label>
                        </div>
                        <div className="flex items-center pl-5">
                          <RadioButton
                            name="homeOrOfficeOrNone"
                            value="Office"
                            checked={homeOrOfficeOrNone === 'Office'}
                            onChange={e => {
                              handleChange(e);
                              onChangeHomeOffice(e);
                            }}
                            onBlur={handleBlur}
                          />

                          <label
                            htmlFor="office"
                            className="text-black-400 text-sm m-2"
                          >
                            Office
                          </label>
                        </div>
                        <div className="flex items-center pl-5">
                          <RadioButton
                            name="homeOrOfficeOrNone"
                            value="None"
                            checked={homeOrOfficeOrNone === 'None'}
                            onChange={e => {
                              handleChange(e);
                              onChangeHomeOffice(e);
                            }}
                            onBlur={handleBlur}
                          />

                          <label
                            htmlFor="None"
                            className="text-black-400 text-sm m-2"
                          >
                            None
                          </label>
                        </div>
                      </div>
                      {errors.homeOrOfficeOrNone && (
                        // touched.homeOrOfficeOrNone &&
                        <div className="text-red-100 text-left">
                          {errors.homeOrOfficeOrNone}
                        </div>
                      )}
                    </div>
                  )}

                  {/* ///////for office only */}
                  {shouldShow('STEP-2-isOffice') &&
                    homeOrOfficeOrNone === 'Office' && (
                      <>
                        <div className="flex flex-col xl:flex-row items-start mt-6 xl:mt-12">
                          <div className="flex items-center mb-2">
                            <RadioButton
                              name="selectOffice"
                              value="notOffice"
                              checked={selectOffice === 'notOffice'}
                              onChange={e => {
                                handleChange(e);
                                onChangeOffice(e);
                              }}
                              onBlur={handleBlur}
                            />
                            <label
                              htmlFor="Owned"
                              className="text-black-400 text-sm m-2"
                            >
                              I do not have office
                            </label>
                          </div>
                          <div className="flex items-center xl:pl-5">
                            <RadioButton
                              name="selectOffice"
                              value="haveOffice"
                              checked={selectOffice === 'haveOffice'}
                              onChange={e => {
                                handleChange(e);
                                onChangeOffice(e);
                              }}
                              onBlur={handleBlur}
                            />

                            <label
                              htmlFor="office"
                              className="text-black-400 text-sm m-2"
                            >
                              Office Address
                            </label>
                          </div>
                        </div>
                        {errors.selectOffice && touched.selectOffice && (
                          <div className="text-red-100 text-left">
                            {errors.selectOffice}
                          </div>
                        )}
                      </>
                    )}
                  {/* for office only end */}

                  {/* ////// end adding new option home or office////// */}
                  {shouldShow('STEP-2') && homeOrOfficeOrNone === 'Home' && (
                    <div className="for_alignment_residence">
                      <div className="residence-container flex flex-col mt-12 mr-12">
                        <div className="text-sm text-left text-black-400 font-bold text-roboto mb-2">
                          Current residence Type :
                        </div>
                        <div className="flex fex-col items-start">
                          <div className="flex items-center mb-2">
                            <RadioButton
                              name="selectType"
                              value="Owned"
                              checked={selectType === 'Owned'}
                              onChange={e => {
                                handleChange(e);
                                onChangeRadio(e);
                              }}
                              onBlur={handleBlur}
                            />
                            <label
                              htmlFor="Owned"
                              className="text-black-400 text-sm m-2"
                            >
                              Owned
                            </label>
                          </div>
                          <div className="flex items-center pl-5">
                            <RadioButton
                              name="selectType"
                              value="Rented"
                              checked={selectType === 'Rented'}
                              onChange={e => {
                                handleChange(e);
                                onChangeRadio(e);
                              }}
                              onBlur={handleBlur}
                            />

                            <label
                              htmlFor="Rented"
                              className="text-black-400 text-sm m-2"
                            >
                              Rented
                            </label>
                          </div>
                        </div>
                        {errors.selectType && touched.selectType && (
                          <div className="text-red-100 text-left">
                            {errors.selectType}
                          </div>
                        )}
                      </div>

                      {/* 2nd option start*/}

                      {shouldShow('STEP-3') &&
                        homeOrOfficeOrNone === 'Home' &&
                        selectType === 'Owned' && (
                          <>
                            <div className="residence-OwnType-container text-left mt-12">
                              <div className="text-sm text-black-400 font-bold text-roboto mb-2">
                                Residence Owned Type :
                              </div>
                              <div className="flex-col flex xl:flex-row xl:justify-between xl:items-start">
                                <div className="flex items-center mb-2">
                                  <RadioButton
                                    name="residenceOwnedType"
                                    value={'parent'}
                                    checked={residenceOwnedType === 'parent'}
                                    onChange={e => {
                                      handleChange(e);
                                      onChangeResidenceOwnedType(e);
                                    }}
                                    onBlur={handleBlur}
                                  />

                                  <label
                                    htmlFor="parent"
                                    className="text-black-400 text-sm m-2"
                                  >
                                    Parent
                                  </label>
                                </div>
                                <div className="flex items-center mb-2">
                                  <RadioButton
                                    name="residenceOwnedType"
                                    value={'self'}
                                    checked={residenceOwnedType === 'self'}
                                    // onChange={onChangeResidenceOwnedType}
                                    onChange={e => {
                                      handleChange(e);
                                      onChangeResidenceOwnedType(e);
                                    }}
                                    onBlur={handleBlur}
                                  />

                                  <label
                                    htmlFor="self"
                                    className="text-black-400 text-sm m-2"
                                  >
                                    Self
                                  </label>
                                </div>
                                <div className="flex items-center mb-2">
                                  <RadioButton
                                    name="residenceOwnedType"
                                    value={'other'}
                                    checked={residenceOwnedType === 'other'}
                                    onChange={e => {
                                      handleChange(e);
                                      onChangeResidenceOwnedType(e);
                                    }}
                                    onBlur={handleBlur}
                                  />

                                  <label
                                    htmlFor="other"
                                    className="text-black-400 text-sm m-2"
                                  >
                                    Other Family Member
                                  </label>
                                </div>
                              </div>
                              {errors.residenceOwnedType &&
                                touched.residenceOwnedType && (
                                  <div className="text-red-100 text-left">
                                    {errors.residenceOwnedType}
                                  </div>
                                )}
                            </div>
                          </>
                        )}

                      {/* 2nd option end*/}
                    </div>
                  )}
                  {/* Current Accomodation Type end*/}

                  {/* 3rd step start */}
                  <div className="mt-12 flex justify-between items-end for_alignment">
                    {shouldShow('STEP-4') &&
                      homeOrOfficeOrNone === 'Home' &&
                      selectType === 'Owned' && (
                        <div className="Upload-Address-Proof">
                          <div className="text-sm text-left text-black-400 font-bold text-roboto mb-2">
                            Upload Address Proof
                          </div>
                          <div className=" w-56 xl:w-48 shadow">
                            <Select
                              name="selectedOption"
                              placeholder="Select"
                              options={uploadTypeOptions}
                              value={selectedOption}
                              onChange={data => {
                                handleSelectOption(data);
                              }}
                              onBlur={handleBlur}
                            />
                          </div>

                          {errors.selectedOption && touched.selectedOption && (
                            <div className="text-red-100 text-left">
                              {errors.selectedOption}
                            </div>
                          )}
                        </div>
                      )}

                    {shouldShow('STEP-5') &&
                      homeOrOfficeOrNone === 'Home' &&
                      selectType === 'Owned' &&
                      selectedOption.value === 'UtilityBill' && (
                        <div>
                          <div
                            className="utility-container text-grey-600 font-normal 
                       xl:flex xl:justify-around mt-8 xl:mt-0"
                          >
                            <div className="flex items-center">
                              <RadioButton
                                name="utilityBill.utilityBillType"
                                value="LPG"
                                checked={utilityBill.utilityBillType === 'LPG'}
                                onChange={onChangeUtilityOptions}
                              />

                              <label
                                htmlFor="LPG"
                                className="text-black-400 text-lg xl:text-sm m-2"
                              >
                                LPG
                              </label>
                            </div>
                            <div className="flex items-center ">
                              <RadioButton
                                name="utilityBill.utilityBillType"
                                value="PNG"
                                checked={utilityBill.utilityBillType === 'PNG'}
                                onChange={onChangeUtilityOptions}
                              />

                              <label
                                htmlFor="PNG"
                                className="text-black-400 text-lg xl:text-sm m-2"
                              >
                                PNG
                              </label>
                            </div>

                            {/* <div className="flex items-center">
                              <RadioButton
                                name="utilityBill.utilityBillType"
                                value="ElectricityBill"
                                checked={
                                  utilityBill.utilityBillType ===
                                  'ElectricityBill'
                                }
                                onChange={onChangeUtilityOptions}
                              />

                              <label
                                htmlFor="ElectricityBill"
                                className="text-black-400 text-lg xl:text-sm m-2"
                              >
                                E Bill
                              </label>
                            </div> */}
                          </div>
                          {errors['utilityBill.utilityBillType'] &&
                            touched.utilityBill.utilityBillType && (
                              <div className="text-red-100 text-left">
                                {errors['utilityBill.utilityBillType']}
                              </div>
                            )}
                        </div>
                      )}
                  </div>

                  {/* 3rd step end */}
                  {/* rented component */}
                  {shouldShow('STEP-3-Rented') &&
                    homeOrOfficeOrNone === 'Home' &&
                    selectType === 'Rented' && (
                      <RentedUpload
                        setstepsInfo={setstepsInfo}
                        data={data}
                        errors={errors}
                        touched={touched}
                        setData={setData}
                        // handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldError={setFieldError}
                        setFileUploadErrors={setFileUploadErrors}
                        fileUploadErrors={fileUploadErrors}
                        name="rented.files"
                        handleChange={e => {
                          setFieldTouched(e.target.name, true);
                          handleChange(e);
                        }}
                      />
                    )}
                  {shouldShow('STEP-2-haveOffice') &&
                    homeOrOfficeOrNone === 'Office' &&
                    selectOffice === 'haveOffice' && (
                      <OfficeUpload
                        setstepsInfo={setstepsInfo}
                        data={data}
                        setData={setData}
                        errors={errors}
                        touched={touched}
                        handleChange={e => {
                          setFieldTouched(e.target.name, true);
                          handleChange(e);
                        }}
                        handleBlur={handleBlur}
                        setFieldError={setFieldError}
                        setFileUploadErrors={setFileUploadErrors}
                        fileUploadErrors={fileUploadErrors}
                        name="office.files"
                      />
                    )}

                  {shouldShow('STEP-10-DL') &&
                    selectType === 'Owned' &&
                    homeOrOfficeOrNone === 'Home' &&
                    selectedOption.value === 'DrivingLicense' &&
                    residenceOwnedType && (
                      <NewDrivingLicense
                        setFieldValue={setFieldValue}
                        setFieldError={setFieldError}
                        setFieldTouched={setFieldTouched}
                        setstepsInfo={setstepsInfo}
                        touched={touched}
                        errors={errors}
                        data={data}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setData={setData}
                      />
                    )}

                  {/* calling voterId here */}

                  {shouldShow('STEP-16') &&
                    homeOrOfficeOrNone === 'Home' &&
                    selectType === 'Owned' &&
                    selectedOption.value === 'VoterID' && (
                      <VoterID setCanProceed={setCanProceed} />
                    )}

                  {shouldShow('STEP-17') &&
                    homeOrOfficeOrNone === 'Home' &&
                    selectType === 'Owned' &&
                    selectedOption.value === 'Passport' && (
                      <PassportComp setCanProceed={setCanProceed} />
                    )}

                  {shouldShow('STEP-6-LPG') &&
                    homeOrOfficeOrNone === 'Home' &&
                    utilityBill.utilityBillType === 'LPG' &&
                    selectType === 'Owned' &&
                    selectedOption.value === 'UtilityBill' && (
                      <UtilityOptionsUpload
                        touched={touched}
                        setFieldTouched={setFieldTouched}
                        setTouched={setTouched}
                        errors={errors}
                        setErrors={setErrors}
                        setstepsInfo={setstepsInfo}
                        setFileUploadErrors={setFileUploadErrors}
                        fileUploadErrors={fileUploadErrors}
                        data={data}
                        setData={setData}
                        options={[
                          { value: 'bharatGas', label: 'Bharat Gas' },
                          { value: 'HPGas', label: 'HP' },
                          { value: 'IndianGas', label: 'Indane' }
                        ]}
                        idLabel="Enter LPG ID/Consumer ID "
                        uploadTxt="Upload LPG"
                        name="utilityBill.files"
                        handleChange={e => {
                          setFieldTouched(e.target.name, true);
                        }}
                      >
                        <UtilityFieldLabels
                          onChange={e => {
                            setData('utilityBill.consumerID', e.target.value);
                          }}
                          idLabel={'Consumer ID:'}
                          name="utilityBill.consumerID"
                          value={utilityBill.consumerID}
                          onBlur={handleBlur}
                          errors={errors}
                          touched={touched}
                        />
                      </UtilityOptionsUpload>
                    )}
                  {shouldShow('STEP-7-PNG') &&
                    homeOrOfficeOrNone === 'Home' &&
                    utilityBill.utilityBillType === 'PNG' &&
                    selectType === 'Owned' &&
                    selectedOption.value === 'UtilityBill' && (
                      <UtilityOptionsUpload
                        setFieldTouched={setFieldTouched}
                        fileUploadErrors={fileUploadErrors}
                        touched={touched}
                        setFileUploadErrors={setFileUploadErrors}
                        setTouched={setTouched}
                        setErrors={setErrors}
                        errors={errors}
                        name="utilityBill.files"
                        handleChange={e => {
                          setFieldTouched(e.target.name, true);
                        }}
                        setstepsInfo={setstepsInfo}
                        data={data}
                        setData={setData}
                        options={[
                          { value: 'IG', label: 'Indraprastha Gas' },
                          { value: 'AG', label: 'Adani Gas' },
                          { value: 'MG', label: 'Mahangar Gas' }
                        ]}
                        idLabel="Consumer ID"
                        uploadTxt="Upload PNG"
                      >
                        {(() => {
                          if (utilityServiceProvider === 'IG') {
                            return (
                              <UtilityFieldLabels
                                onChange={e => {
                                  setData(
                                    'utilityBill.buisnessPartnerNo',
                                    e.target.value
                                  );
                                }}
                                idLabel={'Business Partner ID :'}
                                name="utilityBill.buisnessPartnerNo"
                                value={utilityBill.buisnessPartnerNo}
                                onBlur={handleBlur}
                                errors={errors}
                                touched={touched}
                              />
                            );
                          }

                          if (utilityServiceProvider === 'AG') {
                            return (
                              <UtilityFieldLabels
                                onChange={e => {
                                  setData(
                                    'utilityBill.consumerID',
                                    e.target.value
                                  );
                                }}
                                idLabel={'Consumer ID :'}
                                name="utilityBill.consumerID"
                                value={utilityBill.consumerID}
                                onBlur={handleBlur}
                                errors={errors}
                                touched={touched}
                              />
                            );
                          }

                          if (utilityServiceProvider === 'MG') {
                            return (
                              <>
                                <UtilityFieldLabels
                                  onChange={e => {
                                    setData(
                                      'utilityBill.buisnessPartnerNo',
                                      e.target.value
                                    );
                                  }}
                                  idLabel={'Business Partner ID :'}
                                  name="utilityBill.buisnessPartnerNo"
                                  value={utilityBill.buisnessPartnerNo}
                                  onBlur={handleBlur}
                                  errors={errors}
                                  touched={touched}
                                  classesFromProps="mb-10"
                                />
                                <UtilityFieldLabels
                                  onChange={e => {
                                    setData(
                                      'utilityBill.consumerID',
                                      e.target.value
                                    );
                                  }}
                                  idLabel={'Consumer ID :'}
                                  name="utilityBill.consumerID"
                                  value={utilityBill.consumerID}
                                  onBlur={handleBlur}
                                  errors={errors}
                                  touched={touched}
                                />
                              </>
                            );
                          }
                        })()}
                      </UtilityOptionsUpload>
                    )}
                  {shouldShow('STEP-8-E-BILL') &&
                    homeOrOfficeOrNone === 'Home' &&
                    utilityBill.utilityBillType === 'ElectricityBill' &&
                    selectType === 'Owned' &&
                    selectedOption.value === 'UtilityBill' && (
                      <UtilityOptionsUpload
                        setstepsInfo={setstepsInfo}
                        data={data}
                        setData={setData}
                        options={[
                          { value: 'BESCOM', label: 'BESCOM' },
                          { value: 'BESCOM1', label: 'BESCOM1' },
                          { value: 'BESCOM2', label: 'BESCOM2' }
                        ]}
                        idLabel="Consumer ID"
                        uploadTxt="Upload Electricity Bill"
                      >
                        <UtilityFieldLabels
                          onchange={e => {
                            setData('utilityBill.consumerID', e.target.value);
                          }}
                          idLabel={'Consumer ID:'}
                        />
                      </UtilityOptionsUpload>
                    )}

                  <div className=" flex justify-center">
                    <button
                      type="submit"
                      style={{
                        gridColumn: '2',
                        justifySelf: 'center',
                        marginTop: '60px'
                      }}
                      disabled={!submitValidator()}
                      className="submitButton w-64 text-xl"
                    >
                      VERIFY & PROCEED
                    </button>
                  </div>
                </div>
              </div>
            )}

            {shouldShow('STEP-11') && (
              <DrivingLicenseDetails
                formik={formik}
                setstepsInfo={setstepsInfo}
                data={data}
                setData={setData}
              />
            )}
            {shouldShow('STEP-12') && (
              <UtilityOptionsDetails
                gassbillImgUrl={data.utilityBill.imgUrl[0]}
                setstepsInfo={setstepsInfo}
                data={data}
                setData={setData}
                options={getUtilityDetailsOptions()}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                name="utilityBill.files"
                touched={touched}
                setTouched={setTouched}
                errors={errors}
                setErrors={setErrors}
                handleChange={e => {
                  setFieldTouched(e.target.name, true);
                }}
              />
            )}

            {shouldShow('STEP-13') && (
              <UtilityOptionsDetails
                gassbillImgUrl={data.utilityBill.imgUrl[0]}
                setstepsInfo={setstepsInfo}
                data={data}
                setData={setData}
                options={getUtilityDetailsOptions()}
                setFileUploadErrors={setFileUploadErrors}
                fileUploadErrors={fileUploadErrors}
                name="utilityBill.files"
                touched={touched}
                setTouched={setTouched}
                errors={errors}
                setErrors={setErrors}
                handleChange={e => {
                  setFieldTouched(e.target.name, true);
                }}
              />
            )}

            {shouldShow('STEP-14') && (
              <UtilityOptionsDetails
                gassbillImgUrl={data.utilityBill.imgUrl[0]}
                setstepsInfo={setstepsInfo}
                data={data}
                setData={setData}
                options={[
                  {
                    place_holder: 'Consumer Name',
                    type: 'text',
                    disable: false
                  },
                  {
                    place_holder: 'Bill Date',
                    type: 'text',
                    disable: true
                  },
                  {
                    place_holder: 'Address',
                    type: 'text',
                    disable: false
                  }
                ]}
              />
            )}
          </>
        );
      }}
    </Formik>
  );
};

export default AddressProof;
